'use client';

import { Badge } from '@/components/atoms/badge';
import { cn } from '@/lib/utils';

const BADGE_STYLES: Record<string, string> = {
  ZIP_MATCH: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300',
  CITY_MATCH: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-300',
  ORG_DEFAULT: 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300',
  MANUAL: 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-300',
  POLICY: 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/40 dark:text-indigo-300',
  EXEMPT: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300',
  NONE: 'bg-muted text-muted-foreground',
};

const BADGE_LABELS: Record<string, string> = {
  ZIP_MATCH: 'ZIP Match',
  CITY_MATCH: 'City Match',
  ORG_DEFAULT: 'Org Default',
  MANUAL: 'Manual',
  POLICY: 'Tax Rule',
  EXEMPT: 'Exempt',
  NONE: 'No Match',
};

interface TaxBadgeProps {
  resolvedFrom: string | null | undefined;
  className?: string;
}

export function TaxBadge({ resolvedFrom, className }: TaxBadgeProps) {
  const key = resolvedFrom || 'NONE';
  const style = BADGE_STYLES[key] || BADGE_STYLES.NONE;

  return (
    <Badge variant="outline" className={cn('border-transparent text-[11px]', style, className)}>
      {BADGE_LABELS[key] || key}
    </Badge>
  );
}
